import * as FingerprintJSPro from '@fingerprintjs/fingerprintjs-pro';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { useEffect, useState } from 'react';

const API_KEY = process.env.REACT_APP_FINGERPRINT_API_KEY;

export default function useFingerprint() {
  const [fpHash, setFpHash] = useState('');

  // create and set the fingerprint as soon as
  // the component mounts
  useEffect(() => {
    const setFp = async () => {
      let fp;
      // try PROD version
      try {
        if (API_KEY) {
          fp = await FingerprintJSPro.load({ apiKey: API_KEY });
        }
      } catch {
        // do nothing
      }

      // try FREE version for all env except PROD
      if (!fp?.get) {
        try {
          fp = await FingerprintJS.load();
        } catch {
          // do nothing
        }
      }

      // get the ID
      try {
        if (fp?.get) {
          const { visitorId } = await fp.get();
          setFpHash(visitorId);
        }
      } catch {
        // do nothing
      }
    };

    setFp();
  }, []);

  return `${fpHash}`;
}
